export { attachmentVariables as attachmentBodyVariables } from './attachmentVariables';
